/**
 * The one line about cloud saves that the TITLE shows. Most of the time there is nothing to say: the sync
 * is off, in step, sending, or waiting for the server - none of which the player has to do anything about.
 * Two states are different, because both mean "what is on the server is not what you may think it is":
 *
 *   `paused`             nothing more is sent from this device until the game is started again - its saves
 *                        are local only for the rest of the session (another device saved under the same
 *                        code, the server refused, or a code was just loaded);
 *   `conflict-resolved`  two devices had both played; one save was kept and the other stored as a backup.
 *
 * The port's own `message` says why, or which save won; the fallbacks are for a port that sends none.
 * Pure: the title screen (title.ts) owns the element and the subscription.
 */

import type { CloudStateName, CloudStatusView } from './cloudPort';

const NOTICES: Partial<Record<CloudStateName, { label: string; fallback: string }>> = {
  paused: {
    label: 'CLOUD SAVE PAUSED',
    fallback: 'NOTHING MORE IS SENT UNTIL THE GAME IS STARTED AGAIN. UNTIL THEN YOUR SAVES ARE ON THIS DEVICE ONLY.',
  },
  'conflict-resolved': {
    label: 'CLOUD SAVE',
    fallback: 'TWO DEVICES HAD BOTH PLAYED. ONE SAVE WAS KEPT AND THE OTHER STORED AS A BACKUP: SEE OPTIONS, CLOUD SAVE.',
  },
};

/** The title's cloud line for this status, or null when the title should say nothing. */
export function cloudNotice(status: CloudStatusView): string | null {
  const notice = NOTICES[status.state];
  if (notice === undefined) return null;
  return `${notice.label}: ${status.message.trim() !== '' ? status.message.trim() : notice.fallback}`;
}
